import * as React from "react";
import { Dropdown, IDropdownOption, IDropdownStyles, ResponsiveMode } from "@fluentui/react";
import { IMultipleSelectionInput } from "../../../../../interfaces/advancedSearch/IMultipleSelectionInput";

export const MultiChoicePicker: React.FunctionComponent<IMultipleSelectionInput> = props => {
  const [selectedKeys, setSelectedKeys] = React.useState<string[]>([]);

  const handleOnChange = (event: React.FormEvent<HTMLDivElement>, item: IDropdownOption): void => {
    if (item) {
      let selected = item.selected
        ? [...selectedKeys, item.key as string]
        : selectedKeys.filter(key => key !== item.key);
      setSelectedKeys(selected);
      props.handleValueChange(props.searchInputData?.index, selected);
    }
  };

  const dropdownStyles: Partial<IDropdownStyles> = { root: { width: "100%" } };
  return (
    <Dropdown
      // responsiveMode={ResponsiveMode.small}
      placeholder="Select"
      label={props.displayName}
      selectedKeys={selectedKeys}
      onChange={handleOnChange}
      multiSelect
      options={props.choices.map(item => ({ key: item, text: item }))}
      className="xb-sp-input"
      styles={dropdownStyles}
    />
  );
};

export default MultiChoicePicker;
